import React from 'react'

export default function Blog() {
  return (
    <>
      <div className="blog-section-1 bg-neutral-4">
        {/* new start  */}
        <div className="section-space-sm-bottom">
          <div className="container">
            {/* Row 1: Left-aligned "Join Us" */}
            <div className="row g-4 justify-content-start">
              <div className="col-md-5">
                <div className="d-flex align-items-center gap-4 flex-wrap">
                  <div className="w-30 subtitle-flush-x subtitle-flush-x--secondary subtitle_line_7" />
                  <h6 className="mb-0 fs-18 clr-secondary-key fw-extrabold animate-text-from-right">
                    Join Us
                  </h6>
                </div>
              </div>
            </div>

            {/* Row 2: Centered Heading */}
            <div className="row mt-3">
              <div className="col-12 text-center">
                <h4 className="mb-0 clr-neutral-90 fw-extrabold animate-line-3d">
                  Join & Contribute to <span className="clr-grad-1">Zenochain </span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        {/* new end */}
        {/* <div className="section-space-sm-bottom">
          <div className="container">
             <div className="row g-4 justify-content-between">
              <div className="col-md-5">
                <div className="d-flex align-items-center gap-4 flex-wrap">
                  <div className="w-30 subtitle-flush-x subtitle-flush-x--secondary subtitle_line_7" />
                  <h6 className="mb-0 fs-18 clr-secondary-key fw-extrabold animate-text-from-right"> Join Us </h6>
                </div>
              </div>
              <div className="col-md-6 col-xxl-5">
                <h3 className="mb-0 clr-neutral-90 fw-extrabold animate-line-3d"> Join & Contribute to <span className="clr-grad-1"> OwnXChain </span> </h3>
              </div>
            </div> 
            
          </div>
        </div> */}
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div
                className="blog-card-1 top-shadow px-6 py-10 position-relative z-1 overflow-hidden rounded-3 fadein_bottom_13 text-white"
                style={{
                  height: "500px",
                  backgroundImage: "url('assets/img-1/build.png')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* Optional: overlay for contrast */}
                <div className="overlay"></div>
                <div className="position-relative z-1">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="w-12 h-2px white "></div>
                    <span className="d-block fw-bold text-white">Build</span>
                  </div>

                  <div className="blog-card-1__body">
                    <p className="mb-6 mt-5 fs-24">
                      <a className="text-white d-block text-decoration-none">
                        Start building independent dApps for Zenochain  Ecosystem
                      </a>
                    </p>
                    <div className="d-flex align-items-center gap-2">
                      <span className="d-inline-block rounded-circle bg-white" style={{ width: "8px", height: "8px" }}></span>
                      <a href="/" className="text-white fs-14 fw-semibold text-decoration-none">
                        Developer Docs
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div
                className="blog-card-1 top-shadow px-6 py-10 position-relative z-1 overflow-hidden rounded-3 fadein_bottom_13 text-white"
                style={{
                  height: "500px",
                  backgroundImage: "url('assets/img-1/govern.png')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* Optional: overlay for contrast */}
                <div className="overlay"></div>
                <div className="position-relative z-1">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="w-12 h-2px white "></div>
                    <span className="d-block fw-bold text-white">Govern</span>
                  </div>

                  <div className="blog-card-1__body">
                    <p className="mb-6 mt-5 fs-24">
                      <a className="text-white d-block text-decoration-none">
                        Vote on improvement proposals for developments & upgrades
                      </a>
                    </p>
                    <div className="d-flex align-items-center gap-2">
                      <span className="d-inline-block rounded-circle bg-white" style={{ width: "8px", height: "8px" }}></span>
                      <a href="/" className="text-white fs-14 fw-semibold text-decoration-none">
                        Governance Forum
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div
                className="blog-card-1 top-shadow px-6 py-10 position-relative z-1 overflow-hidden rounded-3 fadein_bottom_13 text-white"
                style={{
                  height: "500px",
                  backgroundImage: "url('assets/img-1/advocate.png')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* Optional: overlay for contrast */}
                <div className="overlay"></div>
                <div className="position-relative z-1">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="w-12 h-2px white "></div>
                    <span className="d-block fw-bold text-white">Advocate</span>
                  </div>

                  <div className="blog-card-1__body">
                    <p className="mb-6  mt-5 fs-24">
                      <a className="text-white d-block text-decoration-none">
                        AContribute to Zenochain’s growth by spreading it to masses
                      </a>
                    </p>
                    <div className="d-flex align-items-center gap-2">
                      <span className="d-inline-block rounded-circle bg-white" style={{ width: "8px", height: "8px" }}></span>
                      <a href="/" className="text-white fs-14 fw-semibold text-decoration-none">
                        Apply
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-md-6 hv col-lg-4">
              <div className="blog-card-1 top-shadow px-6 py-10 position-relative z-1 overflow-hidden rounded-3 bg-neutral-10 bg-opacity-6 fadein_bottom_13"  style={{height:"500px"}}>
                <div className="d-flex align-items-center gap-2">
                  <div className="w-12 h-2px bg-primary-key" />
                  <span className="d-block fw-bold clr-primary-key"> Advocate  </span>
                </div>
                <div className="blog-card-1__img">
                  <img src="assets/img-1/advocate.png" alt="image" className="img-fluid h-100 object-fit-cover" />
                </div>
                <div className="blog-card-1__body">
                  <p className="mb-6 fs-24">
                    <a  className="link d-block text"> AContribute to OwnXChain’s growth by spreading it to masses
                    </a>
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <span className="d-inline-block w-1 h-1 rounded-circle bg-neutral-90" />
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLScfyH8Y8-OFIsTLV0bKOqpGB4hddDSeeKnyvpoOCVIHuypBKQ/viewform?usp=sf_link" target='_blank' className="link d-inline-block clr-neutral-90 fs-14 fw-semibold"> Apply  </a>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div
          className="col-12"
          style={{
            padding: '54px 40px',
            backgroundColor: '#fff4e4',
            marginTop: '20px',
          }}
        >
          <div className="container radius card-parth">
            <div className="row">
              <div className="col-12" style={{ backgroundColor: '#121212' }}>
                <div
                  className="section-space-y px-4 top-shadow position-relative z-1 overflow-hidden rounded-3 bg-neutral-key bg-opacity-6"
                  style={{ paddingTop: '20px', paddingBottom: '20px' }}
                >
                  <div className="container">
                    <div className="row d-flex justify-content-between align-items-center">
                      {/* Left Text */}
                      <div className="col-12 col-md-8">
                        <h6
                          className="mb-0 animate-line-3d text-md-start text-center"
                          style={{
                            color: 'white',
                            fontSize: '1.4rem',
                            lineHeight: '1.6',
                          }}
                        >
                          Whether a developer, enthusiast, or casual blockchain person,{" "}
                          <span className="text-white">everyone is welcomed</span>
                        </h6>
                      </div>

                      {/* Right Button */}
                      <div className="col-12 col-md-4 text-md-end text-center mt-3 mt-md-0">
                        <a
                          href="/"
                          className="gradient-btn-1 mb-4 position-relative link d-inline-flex justify-content-center align-items-center gap-2 px-5 py-3 rounded fw-bold text-center"
                        >
                          <span>Join Community</span>
                          <i className="bi bi-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* <img src="assets/img-1/blog-section-1-img-1.png" alt="image" className="img-fluid blog-section-1__img blog-section-1__img--1" />
        <img src="assets/img/blog-section-1-img-2.webp" alt="image" className="img-fluid blog-section-1__img blog-section-1__img--2" /> */}
      </div>

    </>
  )
}
